angular.module( 'mtic' )
.service( 'api', function (
  $log,
  apiMethods
) {
  const {GET, PUT, POST, DELETE} = apiMethods;
  return {
    findStudentNoSchool({uuid, auth_type}) {
      return GET('STUDENT_BY_USERNAME_NOSCHOOL', {
        uuid,
        auth_type
      })
    },
    signUpStudentThroughNoSchoolAll({group_ids,user_name,password,first_name,last_name,email,auth_type, class_data}) {
      return POST('STUDENT_NO_SCHOOL_ALL',{
        group_ids,
        user_info: {
          uuid: user_name,
          secret_key: password,
          auth_type,
          first_name,
          last_name,
          email,
          class_data
        }
      })
    },
    signUpStudentThroughNoSchool({group_id,user_name,password,first_name,last_name,email,auth_type}) {
      return POST('STUDENT_NO_SCHOOL',{
        group_id,
        user_info: {
          uuid: user_name,
          secret_key: password,
          auth_type,
          first_name,
          last_name,
          email,
        }
      })
    },
    getClassesForStudent(){
      return GET('STUDENT_CLASSES', {
      })
    },
    getClassesForSchool(school_id){
      return GET('CLASSES_WITH_MODULES_BY_SCHOOL', {
        school_id
      })
    },
    getSchoolModules(school_id){
      return GET('TEACHER_SCHOOL_MODULES', {
        school_id
      })
    },
    getNoSchoolClasses(noschool_id){
      return GET('NOSCHOOL_CLASSES',{
        noschool_id
      })
    },
    getCountries(noschool) {
      return GET('COUNTRIES', {
        noschool: noschool ? 1 : 0
      });
    },
    linkIam(msfUser, {session_key, user_id}) {
      return PUT('LINK_IAM', msfUser, {
        headers: {
          'X-Auth-Session-Key': session_key,
          'X-Auth-Id': user_id,
        }
      })
    },
    nonSystematicLogin(uuid, secret_key, auth_type) {
      return POST('USER_LOGIN', {
        uuid,
        secret_key,
        auth_type
      })
    },
    validateIAM(iAMProfile) {
      return apiMethods.POST('VALID_IAM', iAMProfile)
    },
    getCustomResource(class_id, resource_id){
      return apiMethods.GET('CLASS_CUSTOM_RESOURCES', {
        class_id: class_id,
        resource_id: resource_id
      })
    },
    updateClass(class_id, class_data){
      return apiMethods.PUT('GROUP', {
        class_id: class_id,
        class_data: class_data
      })
    },
    getStudentCustomResource(resource_id){
      return apiMethods.GET('STUDENT_CUSTOM_RESOURCES', {
        resource_id: resource_id
      })
    },
    updateClassComponentStat(resource_id, component_id, state_update, timestamp){
      return apiMethods.PUT('CLASS_STATE', {
        resource_id: resource_id,
        component_id: component_id,
        state_update: state_update,
        timestamp: timestamp
      })
    },
    getUserGroups(){
      return apiMethods.GET('USER_GROUPS');
    },
    deleteAgendaProperty( class_id, agenda_ids ) {
      return apiMethods.DELETE('CLASS_AGENDA', {
        "class_id": class_id,
        "agenda_ids": agenda_ids,
      })
    },
    updateAgendaProperty( class_id, agenda_id, updates ) {
      return apiMethods.PUT('CLASS_AGENDA', {
        "class_id": class_id,
        "agenda_id": agenda_id,
        "updates": updates
      })
    },
    createAgenda( class_id, sub_module_resource_id, resources, students, agenda_definition ) {
      var intStudentList = [];
      students.forEach( function(student){
        intStudentList.push(parseInt(student));
      })
      agenda_definition.students = intStudentList;//students;
      agenda_definition.resources = resources;
      return apiMethods.POST('CLASS_AGENDA', {
        "class_id": class_id,
        "sub_module_resource_id": sub_module_resource_id,
        "agenda_definition": agenda_definition
      })
    },
    getStudentAgenda( ) {
      return apiMethods.GET('STUDENT_AGENDA')
    },
    getClassAgenda( classId ) {
      return apiMethods.GET('CLASS_AGENDA', { class_id: classId })
    },
    getStudentsAppEvents( class_id, module_id, from, to, limit ) {
      return apiMethods.GET('STUDENT_APP_EVENTS', {
        class_id: class_id,
        module_id: module_id,
        from: from || moment( ).subtract( 7, 'days' ).format( 'YYYY-MM-DD' ),
        to: to || moment( ).format( 'YYYY-MM-DD' ),
        limit: limit || 200
      })
    },
    logout( ) {
      return apiMethods.DELETE( "LOGOUT" );
    },
    getUserInfoById( uuid ) {
      return apiMethods.GET("USER_INFO", { uuid: uuid });
    },
    redeemAccessCode( access_code ) {
      return apiMethods.POST("REDEEM_ACCESS_CODE", {
        code: access_code
      }, { })
    },
    setGroupId(group_id){
      apiMethods.setGroupId( group_id )
    },
    createClass( schoold, className, classDescription ) {
      throw new Error('api.createClass is no longer supported!')
      // apiMethods.setGroupId( schoold )
      // return apiMethods.POST("GROUP", {
      //   "class_name": className,
      //   "class_description": classDescription,
      //   "school_id": schoold
      // }, { })
    },
    createSchoolClass({module_id,school_id,name,description}) {
      return POST('SCHOOL_MODULE_CLASS', {
        module_id,
        school_id,
        name,
        description
      })
    },
    addStudentToClass( code ) {
      return apiMethods.POST("STUDENT_GROUP", {
        "class_id": 16,
        "teacher_id": 11
      }, { })
    },
    signUpTeacherThroughGroup( {group_id, user_name, password, first_name, last_name, email, auth_type, user_type, class_data} ) {
      //console.log('attempting : ', group_id, user_name, password, first_name, last_name, email, auth_type)
      return apiMethods.POST("TEACHER_THROUGH_GROUP", {
        "group_id": Number( group_id ),
        "user_info": {
          "uuid": String( user_name ),
          "secret_key": String( password ),
          "first_name": String( first_name ),
          "last_name": String( last_name ),
          "email": String( email ),
          "auth_type": auth_type ? String( auth_type ) : "localStrategy",
          "class_data": String(class_data)
          //"user_type": String( user_type )
        }
      }, { })
    },
    signUpTeacher( code, user_name, password, first_name, last_name, email, user_type ) {
      return apiMethods.POST("TEACHER", {
        "code": String( code ),
        "user_info": {
          "uuid": String( user_name ),
          "secret_key": String( password ),
          "first_name": String( first_name ),
          "last_name": String( last_name ),
          "email": String( email ),
          "user_type": String( user_type )
        }
      }, { })
    },
    login: apiMethods.login,
    loginRestore: apiMethods.loginRestore,
    signUpStudent( teacher_id, class_id, user_name, password, first_name, last_name, user_type ) {
      return apiMethods.POST("STUDENT", {
        "teacher_id": Number( teacher_id ),
        "class_id": Number( class_id ),
        "user_info": {
          "uuid": String( user_name ),
          "secret_key": String( password ),
          "first_name": String( first_name ),
          "last_name": String( last_name ),
          "user_type": String( user_type )
        }
      }, { })
    },
    transferStudent({teacher_id, from_class_id, to_class_id}){
      return apiMethods.PUT("STUDENT_CLASSES_TRANSFER", {
        from_class_id,
  			to_class_id,
  			teacher_id
      }, {});
    },
    getClassInfo({class_id}) {
      return apiMethods.GET('CLASS_INFO', {class_id});
    },
    getClassMembers( classId, role_type, isArchived ) {
      // console.log('NOW')
      return apiMethods.GET('CLASS_MEMBERS', {
        class_id: classId,
        role_type: role_type,
        archived:isArchived
      });
    },getArchivedStudents( classId,role_type ) {
      return apiMethods.GET('ARCHIVED_STUDENTS', {
        class_id: classId,
        role_type: role_type,
        archived:true
      });
    },
    getStudentClassMembers( classId, role_type ) {
      return apiMethods.GET('STUDENT_CLASS_MEMBERS');
    },
    getClassStats( classId ) {
      return apiMethods.GET('CLASS_SUMMARY_STATS', { class_id: classId });
    },
    getStudentModuleResourceState( module_id ) {
      return apiMethods.GET('STUDENT_MODULE_RESOURCE_STATE', { module_id: module_id });
    },
    getStudentModuleResourceStateByTeacher( module_id, user_id, class_id ) {
      return apiMethods.GET('TEACHER_STUDENT_MODULE_RESOURCE_STATE', {
        module_id: module_id,
        user_id: user_id,
        class_id: class_id
      });
    },
    getClassResourceStates( class_id, isArchived, omitStateLogs, workspace_logs, user_id, resource_id ) {
      return apiMethods.GET('CLASS_RESOURCE_STATES', { class_id: class_id , archived:isArchived, omit_logs: omitStateLogs, workspace_logs: workspace_logs, user_id: user_id, resource_id: resource_id});
    },
    getClassModuleMaps( groupId ) {
      return apiMethods.GET('CLASS_MODULES', { class_id: groupId });
    },
    submitStudentResourceState( resourceState ) {
      return apiMethods.POST( 'STUDENT_RERSOURCE_STATE', resourceState );
    },
    submitCopiedStudentResourceState( resourceState ) {
      return apiMethods.POST( 'STUDENT_RERSOURCE_STATE_COPIED', resourceState );
    },
    submitItemEndQuestionaire( resourceId, data ) {
      return apiMethods.POST('GENERAL_LOG', {
        resource_id: resourceId,
        tag: 'end-questionaire',
        data: data
      });
    },
    sendEvent( eventData ) {
      return apiMethods.POST( 'EVENT', eventData );
    },
    getUserResourceAppState(user_id, resource_id){
      return apiMethods.GET('GET_USER_RESOURCE_APP_STATE', {
        user_id: user_id,
        resource_id: resource_id
      });
    },
    getUserResourceLatestAppState(user_id, resource_id, since_date, up_to_date){
      return apiMethods.GET('GET_USER_RESOURCE_LATEST_APP_STATE', {
        user_id,
        resource_id,
        since_date,
        up_to_date
      });
    },
    //THE LAST APP STATE ONE SHOULD BE DEPRECATED!
    getUserResourceLastAppState(user_id, resource_id){
      return apiMethods.GET('GET_USER_RESOURCE_LAST_APP_STATE', {
        user_id: user_id,
        resource_id: resource_id
      });
    },
    archiveStudent(class_id, user_id,isArchived){
      return apiMethods.POST('ARCHIVE_STUDENT', {
        class_id: class_id,
        user_id: user_id,
        archive: isArchived||false
      });
    },
    updateClassArchiveStatus(class_id,isArchived){
      return apiMethods.PUT('UPDATE_CLASS_ARCHIVE_STATUS', {
        class_id: class_id,
        archive: isArchived||false
      });
    },
    getCompetitionLeaderBoard(comp_id){
      return apiMethods.GET('GET_LEADERBOARD', {
        competition_id: comp_id
      });
    },
    getLeaderBoardTopPerformer(agenda_id){
      return apiMethods.GET('GET_LEADERBOARD_TOP_PERFORMER', {
        agenda_id: agenda_id
      });
    },
    syncLeaderboard(competition_id){
      return apiMethods.GET('GET_SYNC_LEADERBOARD', {
        competition_id: competition_id
      });
    },
    getStudentAssessmentPdf(student_id, diagnostic_assessment_resource_id, group_id){
      return apiMethods.GET('GET_STUDENT_ASSESSMENT_PDF', {
        student_id, 
        diagnostic_assessment_resource_id,
        group_id
      });
    },
    getClassAssessmentData(diagnostic_assessment_resource_id, group_id, date_open, date_close){
      return apiMethods.GET('GET_CLASS_ASSESSMENT_DATA', {
        diagnostic_assessment_resource_id,
        group_id,
        date_from: date_open,
        date_to: date_close
      });
    },
    getPdfAvailability(user_id, group_id){
      return apiMethods.GET('GET_PDF_AVAILABILITY', {
        user_id,
        group_id
      });
    },
    initStateLogSession(user_id, resource_id, module_id, class_id, working_session_hash, assessment_session_hash){
      return apiMethods.POST('STATE_LOG_SESSION', {
        user_id,
        resource_id,
        module_id,
        class_id, 
        working_session_hash,
        assessment_session_hash
      })
    },
    importAgenda(class_id, agenda_code){
      return apiMethods.POST('IMPORT_AGENDA', {
        class_id,
        agenda_code
      })
    },
    getUserNotifications(user_id){
      return apiMethods.GET('GET_USER_NOTIFICATIONS', {
        user_id
      });
    },
    logNotificationState(user_id, notification_id, log_state, update_logs){
      // TO DO: create new route which allows to update log_state with time stamp without marking as dismissed
      return apiMethods.POST('NOTIFICATION_SEEN', {
        user_id,
        notification_id,
        log_state,
        instance_id: null,
        update_logs
      });
    },
    dismissNotification(user_id, notification_id, log_state, instance_id){
      return apiMethods.POST('NOTIFICATION_DISMISSED', {
        user_id,
        notification_id,
        log_state,
        instance_id
      });
    },
    archiveNotification(user_id, notification_id, instance_id){
      return apiMethods.POST('NOTIFICATION_ARCHIVE', {
        user_id,
        notification_id,
        instance_id
      });
    },
    postUserNotification(message_type, user_id, from_user_id, log_state){
      return apiMethods.POST('POST_NOTIFICATION', {
        message_type,
        user_id,
        from_user_id,
        log_state
      });
    },    
    postResourceTimeUpdate(working_session_hash, ping_update){
      return apiMethods.POST('POST_RESOURCE_TIME', {
        working_session_hash,
        ping_update
      });
    },
    postUserPasswordUpdate(user_id, secret_key, group_id){
      return apiMethods.POST('UPDATE_PASSWORD', {
        user_id,
        secret_key,
        group_id
      });
    },
    postTeacherPasswordUpdate(secret_key){
      return apiMethods.POST('UPDATE_TEACHER_PASSWORD', {
        secret_key
      });
    },
    setUserLanguage(language){
      return apiMethods.POST('UPDATE_USER_LANGUAGE', {
        language
      });
    },
    getCountryOfClass(class_id) {
      return apiMethods.GET('CLASS_COUNTRY', {
        class_id
      });
    }
  }
});
